import { generateUUID } from '@/common/utils/commonUtils';
import {
  BucketAggregation,
  BucketAggregationsType,
  DateHistogramBucketAggregations,
  FiltersBucketAggregations,
  HistogramBucketAggregations,
  TermsBucketAggregations,
} from './BucketAggregation';

export class BucketAggregationFactory {
  static createBucketAggregation(
    type: BucketAggregationsType,
    show: boolean = true,
  ): BucketAggregation {
    switch (type) {
      case 'dateHistogram':
        return new DateHistogramBucketAggregations(generateUUID(), show);
      case 'filters':
        return new FiltersBucketAggregations(generateUUID(), show);
      case 'histogram':
        return new HistogramBucketAggregations(generateUUID(), show);
      case 'terms':
        return new TermsBucketAggregations(generateUUID(), show);
      default:
        throw new Error(`Unknown bucket aggregation type: ${type}`);
    }
  }
}
